module.exports = __webpack_public_path__ + "static/media/modelo-cliente-oportunidade-v1.f820c271.csv";